import { object, string, date, number } from 'yup';

export const baseSchema = object({
    name: string().required(),
    createdBy: string().email().required(),
    createdAt: date().required(),
    modifiedBy: string().email().required(),
    modifiedAt: date().required()
});

export const createSchema = baseSchema.shape({});

export const updateSchema = baseSchema.shape({
    id: number().required()
});